import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import HeaderRec from '../../../header/headerRec';
import axios from 'axios';
import { useLocation, useParams } from 'react-router-dom';
import { Box, Paper, Tabs, Tab, Typography, Tooltip, Divider, Card, Avatar, CardContent, FormControl, Select, MenuItem, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
import CustomAlert from '../../../commun/CustomAlert';
import MissionInfo from './MissionInfo';
import ProfilRecherche from './ProfilRecherche';
import ComplementaireInfos from './ComplementaireInfos';
import CvViewer from './CvViewer';
import NotesTab from './NotesTab';
import HistoriqueTab from './HistoriqueTab';
import ProfilAnonymise from './ProfilAnonymise';
import Footer from '../../../commun/Footer';
import TalentInsightsCard from './TalentInsightsCard';
import PresentationModal from './PresentationModal';
import LoadingPage from '../../../commun/LoadingPopup';
import './detailTalent.css';
import { Stack } from '@mui/system';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import Chatbox from '../../../commun/ChatBox';
import MissionCard from '../../../commun/MissionCard';
import { statusOptions, statusOptionsRecruteur } from '../../../commun/constants/options';
import NotFound404 from '../../../commun/NotFound404';


const DetailTalent = ({ talentId: propTalentId, isModal = false, onUpdate = () => {} }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedTalent, setSelectedTalent] = useState(null);
  const [notFound, setNotFound] = useState(false);

  const handleFieldChange = (field, value) => {
    const cleanedValue = typeof value === 'string' ? value.replace(/^"+|"+$/g, '') : value;
    setEditableTalent(prev => ({
      ...prev,
      [field]: cleanedValue,
    }));
  };

  const handleClose = () => setModalOpen(false);
  const navigate = useNavigate();
  const { talentId: paramTalentId } = useParams();
  const talentId = propTalentId || paramTalentId;
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const [talent, setTalent] = useState(null);
  const location = useLocation();
  const formData = location.state?.plainFormData;
  const [editableTalent, setEditableTalent] = useState();
  const [activeTab, setActiveTab] = useState(0);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertSeverity, setAlertSeverity] = useState('success');
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState('');
  const [pendingSave, setPendingSave] = useState(null);

  const recruteurName = localStorage.getItem("recruteurName");
  const authToken = localStorage.getItem("authToken");
  const userId = localStorage.getItem("userId");
  const userRole = localStorage.getItem("userType");
  const [isEditing, setIsEditing] = useState(false);
  const [missions, setMissions] = useState([]);
  const role = ['admin', 'commercial', 'agent'].includes(userRole);

  const ENDPOINTS = {
    getTalent: role
      ? `${API_BASE}/api/admin/talent/${talentId}`
      : `${API_BASE}/api/recruteur/talent/${talentId}`,
    updateTalent: role
      ? `${API_BASE}/api/admin/update-talent/${talentId}`
      : `${API_BASE}/api/recruteur/update-talent/${talentId}`,
    updateCandidat: `${API_BASE}/api/admin/edit-candidat-st/${talentId}`, 
  };

  const safeJsonParse = (v) => {
    try { return JSON.parse(v); } catch { return v; }
  };

  const isValidValue = (value) => {
    if (value === null || value === undefined) return false;
    if (typeof value === 'string') {
      const cleaned = value.trim().replace(/^"|"$/g, '');
      return cleaned !== '' && cleaned.toLowerCase() !== 'null' && cleaned !== '[]';
    }
    if (Array.isArray(value)) {
      return value.length > 0;
    }
    if (typeof value === 'object') {
      return Object.keys(value).length > 0;
    }
    return true;
  };

  const fetchSuggestedMissions = async (talentId) => {
    try {
      const res = await fetch(`${API_BASE}/api/matching/suggestions-mission/${talentId}`);
      const data = await res.json();
      setMissions(data);
      return data;
    } catch (err) {
      console.error("Erreur récupération missions suggérées :", err);
      return [];
    }
  };

  useEffect(() => {
    const fetchTalent = async () => {
      try {
        if (!authToken) {
          setAlertMessage("Session expirée. Veuillez vous reconnecter.");
          setAlertSeverity("error");
          setAlertOpen(true);
          navigate("/login");
          return;
        }

        let res;
        try {
          res = await axios.get(ENDPOINTS.getTalent, {
            headers: { Authorization: `Bearer ${authToken}` }
          });
        } catch (error) {
          if (error.response?.status === 404) {
            setAlertMessage("Talent introuvable.");
            setAlertSeverity("warning");
            setAlertOpen(true);
            setNotFound(true);
            navigate("/dashboard");
            return;
          } else {
            throw error;
          }
        }

        const fetchedData = res.data;
        const safeFormData = formData || {};
        const mergedData = Object.keys(fetchedData).reduce((acc, key) => {
          const formValue = safeFormData[key];
          let parsedFormValue = formValue;
          try {
            if (
              typeof formValue === "string" &&
              (formValue.startsWith("[") || formValue.startsWith("{"))
            ) {
              parsedFormValue = JSON.parse(formValue);
            }
          } catch {
            parsedFormValue = formValue;
          }
          acc[key] = isValidValue(parsedFormValue)
            ? parsedFormValue
            : fetchedData[key];
          return acc;
        }, {});
        mergedData.cvUpload = fetchedData.cvUpload;
        mergedData.statut = fetchedData.statut;
        setTalent(fetchedData);
        setEditableTalent(mergedData);
      } catch (err) {
        console.error("Erreur lors du chargement du talent :", err);
        setNotFound(true);
        if (err.response?.status === 403) {
          navigate("/access-denied");
        } else if (err.response?.status === 401) {
          setAlertMessage("Session expirée. Veuillez vous reconnecter.");
          setAlertSeverity("error");
          setAlertOpen(true);
          navigate("/login");
        } else {
          setAlertMessage("Erreur lors du chargement du talent.");
          setAlertSeverity("error");
          setAlertOpen(true);
        }
      }
    };

    fetchTalent();
    fetchSuggestedMissions(talentId);
  }, [authToken, talentId]);

  const [hasAnonymisedCV, setHasAnonymisedCV] = useState(false);

  useEffect(() => {
    const checkCv = async () => {
      try {
        const res = await axios.get(`${API_BASE}/api/cv-generated/exists/${talentId}`, {
          headers: { Authorization: `Bearer ${authToken}` }
        });
        setHasAnonymisedCV(res.data.exists);
      } catch (err) {
        console.error('Erreur vérification CV anonymisé', err);
        setHasAnonymisedCV(false);
      }
    };

    if (talentId && authToken) checkCv();
  }, [talentId]);

  const handleChange = (_, newValue) => setActiveTab(newValue);

  const performSave = async () => {
    try {
      const fullName = localStorage.getItem("recruteurName");
      const updatedTalent = {
        ...editableTalent,
        recruteurName: fullName,
        langues: typeof editableTalent.langues === 'string' ? safeJsonParse(editableTalent.langues) : editableTalent.langues,
        competences: typeof editableTalent.competences === 'string' ? safeJsonParse(editableTalent.competences) : editableTalent.competences,
      };

      // Construire le payload en incluant les champs modifiés (même s'ils sont vides)
      const payload = {};
      Object.entries(updatedTalent).forEach(([key, value]) => {
        const originalValue = talent?.[key];
        
        // Normaliser les valeurs pour la comparaison
        const normalizeValue = (val) => {
          if (Array.isArray(val)) {
            return JSON.stringify(val.sort());
          }
          if (typeof val === 'string') {
            return val.trim();
          }
          return val;
        };
        
        const normalizedCurrent = normalizeValue(value);
        const normalizedOriginal = normalizeValue(originalValue);
        
        // Inclure le champ s'il a changé
        if (JSON.stringify(normalizedCurrent) !== JSON.stringify(normalizedOriginal)) {
            // Toujours inclure email et phone s'ils ont été modifiés (même s'ils sont vides)
            if (key === 'email' || key === 'phone') {
            payload[key] = value; // Inclure même si vide (tableau vide ou string vide)
          } else {
            // Pour les autres champs, inclure seulement s'ils ne sont pas vides
            if (value !== null && 
              value !== undefined &&
              !(typeof value === 'string' && value.trim() === '') &&
                !(Array.isArray(value) && value.length === 0)) {
              payload[key] = value;
          }
          }
        }
      });

      payload.userId = userId;

      if (!Object.keys(payload).length || (Object.keys(payload).length === 1 && payload.userId)) {
        setAlertMessage("Aucune modification détectée.");
        setAlertSeverity("info");
        setAlertOpen(true);
        return;
      }

      const isCandidat = talent?.origine === 'Candidat';
      const updateUrl = isCandidat ? ENDPOINTS.updateCandidat : ENDPOINTS.updateTalent;

      await axios.put(updateUrl, payload, {
        headers: { Authorization: `Bearer ${authToken}` }
      });

      const res = await axios.get(ENDPOINTS.getTalent, {
        headers: { Authorization: `Bearer ${authToken}` }
      });

      setTalent(res.data);
      setEditableTalent(res.data);
      onUpdate(res.data);
      setAlertMessage("Données mises à jour !");
      setAlertSeverity("success");
      setAlertOpen(true);
    } catch (err) {
      console.error("Erreur mise à jour:", err);

      if (err.response?.status === 401) {
        setAlertMessage("Session expirée. Veuillez vous reconnecter.");
        setAlertSeverity("error");
        setAlertOpen(true);
        navigate("/login");
        return;
      }
      if (err.response?.status === 403) {
        setAlertMessage("Accès refusé : vous n’avez pas les droits pour modifier ce talent.");
        setAlertSeverity("error");
        setAlertOpen(true);
        return;
      }
      setAlertMessage("Erreur lors de la mise à jour.");
      setAlertSeverity("error");
      setAlertOpen(true);
    }
  };

  const saveTalentData = async () => {
    // Vérifier si email ou phone ont été supprimés (passés de non-vide à vide)
    const emailWasRemoved = talent?.email && 
      (Array.isArray(talent.email) ? talent.email.length > 0 : talent.email) &&
      (!editableTalent?.email || 
       (Array.isArray(editableTalent.email) ? editableTalent.email.length === 0 : !editableTalent.email));
    
    const phoneWasRemoved = talent?.phone && 
      (Array.isArray(talent.phone) ? talent.phone.length > 0 : talent.phone) &&
      (!editableTalent?.phone || 
       (Array.isArray(editableTalent.phone) ? editableTalent.phone.length === 0 : !editableTalent.phone));

    // Afficher un dialogue de confirmation moderne si email ou téléphone sont supprimés
    if (emailWasRemoved || phoneWasRemoved) {
      const removedFields = [];
      if (emailWasRemoved) removedFields.push('email');
      if (phoneWasRemoved) removedFields.push('téléphone');
      
      setConfirmMessage(`Vous avez supprimé ${removedFields.join(' et ')}. Voulez-vous continuer ?`);
      setPendingSave(() => performSave);
      setConfirmDialogOpen(true);
      return; // Attendre la confirmation avant de continuer
    }

    // Si pas de suppression, sauvegarder directement
    await performSave();
  };

  const handleConfirmSave = async () => {
    setConfirmDialogOpen(false);
    if (pendingSave) {
      await pendingSave();
      setPendingSave(null);
    }
  };

  const handleCancelSave = () => {
    setConfirmDialogOpen(false);
    setPendingSave(null);
  };

  if (notFound) return <NotFound404 />;

  const otherstatusOptions =
    (userRole === 'admin' || userRole === 'commercial' || userRole === 'agent')
      ? statusOptions
      : statusOptionsRecruteur;

  const getStatusColorClass = (statut) => {
    if (!statut) return 'status-color-default';

    const normalized = statut.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

    if (normalized === 'a traiter') return 'status-color-a-traiter';
    if (normalized === 'qualifie attente controle') return 'status-color-qualifie-attente-controle';
    if (normalized.includes('recrute')) return 'status-color-recrute';

    return 'status-color-default';
  };

    
  return (
      <div className="entreprise-page">
          {!isModal && (
            <HeaderRec recruteurName={recruteurName} authToken={authToken} userId={userId} />
          )}
          <Paper elevation={3} className="tab-container">
               <Tabs
                 value={activeTab}
                 onChange={handleChange}
                 variant="scrollable"
                 scrollButtons="auto"
                 textColor="primary"
                 indicatorColor="primary"
                 TabIndicatorProps={{ sx: { height: 3, borderRadius: 2 } }}
               >
                 <Tab label="Talent" />
                 <Tab label="Formation et Compétences" />
                 <Tab label="Infos complémentaires" />
                 <Tab label="CV Talent" />
                 {userRole !== 'agent' && <Tab label="Profil Anonymisé" />}
                 <Tab label="Historique" />
                 <Tab label="Notes" />
               </Tabs>
          </Paper>
          <main className="pageContainer">
            <div className="contentWrapper">
            <div className="contentGrid">
            {/* ✅ Colonne de gauche */}
            <aside className="leftColumn">
            <div className="contactCardContainer">
             <Card className="contact-card-modern">
               <CardContent>
               <div className="contact-avatar-container">
                 <Stack direction="column" spacing={1} alignItems="center">
                   <Avatar className="contact-avatar-img">{editableTalent?.trigramme?.substring(0, 3).toUpperCase() || 'T'}</Avatar>
                   <Typography variant="h6">
                     {editableTalent?.nomCandidat} {editableTalent?.prenomCandidat}
                   </Typography>
                 </Stack>
                 </div>
                 <Divider sx={{ my: 1 }} />
                 <Typography variant="body2" >
                   <EmailIcon fontSize="small" className="contact-space" /> 
                   {(Array.isArray(editableTalent?.email) ? editableTalent.email : [editableTalent?.email])
                    .filter(Boolean)
                    .join(' , ')}
                 </Typography>
                 <Typography variant="body2" >
                   <PhoneIcon fontSize="small" className="contact-space" />{' '}
                    {(Array.isArray(editableTalent?.phone) ? editableTalent.phone : [editableTalent?.phone])
                      .filter(Boolean)
                      .join(', ')}
                 </Typography>
               </CardContent>
             </Card>
             <TalentInsightsCard
              talent={editableTalent}
              hasAnonymisedProfile={hasAnonymisedCV}
              onPresentClick={() => {
                setSelectedTalent(editableTalent);
                setModalOpen(true);
              }}
            />
            </div>
            </aside>
            {/* ✅ Colonne principale */}
            <section className="mainColumn">  
              <div className="missionContent">
                {activeTab === 0 && (
                <MissionInfo {...{ editableTalent, setEditableTalent, originalTalent: talent, onSave: saveTalentData, formData, onFieldChange: handleFieldChange , isEditing, setIsEditing}} />
                )}
                {activeTab === 1 && (
                  <ProfilRecherche {...{ editableTalent, setEditableTalent, originalTalent: talent, onSave: saveTalentData, formData, onFieldChange: handleFieldChange }} />
                )}
                {activeTab === 2 && (
                  <ComplementaireInfos {...{ editableTalent, setEditableTalent, originalTalent: talent, onSave: saveTalentData, formData, onFieldChange: handleFieldChange }} />
                )}
                {activeTab === 3 && (
                  <CvViewer {...{ talent, apiBase: API_BASE, editableTalent, setEditableTalent, originalTalent: talent, onSave: saveTalentData, formData }} />
                )}
                {activeTab === 4 && <ProfilAnonymise talent={talent} apiBase={API_BASE} />}
                {activeTab === 5 && <HistoriqueTab historique={talent?.historique} />}
                {activeTab === 6 && <NotesTab talentId={editableTalent?._id} origine={editableTalent?.origine} initialNotes={talent?.note} />}      
              </div>
            </section>
            <aside className="sideColumn">
            <div className="talent-card">
                  <Stack className="mission-info-header">
                    {isEditing && editableTalent?.statut !== 'Recruté' ? (
                      <FormControl sx={{ width: 200 }} margin="normal">
                        <Select
                          labelId="statut-label"
                          value={editableTalent?.statut || ''}
                          onChange={(e) => {
                            const newValue = e.target.value;
                            handleFieldChange('statut', newValue);
                          }}                        >
                          <MenuItem value="" disabled>
                            -- Sélectionnez un statut --
                          </MenuItem>
                          {otherstatusOptions.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    ) : (
                    <div className={`status-badge ${getStatusColorClass(editableTalent?.statut)}`}>
                      {
                        statusOptionsRecruteur.find((opt) => opt.value === editableTalent?.statut)?.label ||
                        editableTalent?.statut ||
                        'Non défini'
                      }
                    </div>                                       
                    )}
                  </Stack>

                </div> 
           <MissionCard
              missions={missions}
            />


            <Card className="profil-help-card">
              <CardContent>
                <Typography variant="h6" className="profil-help-title">
                  Aide sur les actions
                </Typography>

                <ul className="profil-help-list">
                    <li>
                    <Tooltip title="Permet de modifier le statut du talent dans le processus de recrutement." arrow>
                      <span className="profil-help-item">🔄 Changer le statut</span>
                    </Tooltip>
                          <li>
                    <Tooltip title="Envoyer ce profil à un client pour proposition ou mission." arrow>
                      <span className="profil-help-item">📤 Bouton « Positionner le profil »</span>
                    </Tooltip>
                  </li>
                  </li>
                      <Typography variant="subtitle2" className="profil-help-subtitle">
                  Navigation des onglets :
                </Typography>
                  <li>
                    <Tooltip title="Consultez les informations personnelles et générales du talent." arrow>
                      <span className="profil-help-item">👤 « Talent »</span>
                    </Tooltip>
                  </li>
                  <li>
                    <Tooltip title="Affiche les diplômes, compétences et expériences du talent." arrow>
                      <span className="profil-help-item">🎓 « Formation et Compétences »</span>
                    </Tooltip>
                  </li>
                  <li>
                    <Tooltip title="Détaille des informations additionnelles (mobilité, disponibilité, etc.)." arrow>
                      <span className="profil-help-item">📁 « Infos complémentaires »</span>
                    </Tooltip>
                  </li>
                  <li>
                    <Tooltip title="Permet de consulter le CV original du talent." arrow>
                      <span className="profil-help-item">📄 « CV Talent »</span>
                    </Tooltip>
                  </li>
                  <li>
                    <Tooltip title="Accès à un CV anonymisé pour le partage sans informations sensibles." arrow>
                      <span className="profil-help-item">🕵️ « Profil Anonymisé »</span>
                    </Tooltip>
                  </li>
                  <li>
                    <Tooltip title="Historique complet des actions réalisées sur le profil." arrow>
                      <span className="profil-help-item">📜 « Historique »</span>
                    </Tooltip>
                  </li>
                  <li>
                    <Tooltip title="Ajouter ou consulter vos notes personnelles sur le talent." arrow>
                      <span className="profil-help-item">📝 « Notes »</span>
                    </Tooltip>
                  </li>


                </ul>
              </CardContent>
            </Card>

             <PresentationModal
               open={modalOpen}
               onClose={handleClose}
               talent={selectedTalent}
               apiBase={API_BASE}
             />
            </aside>
            </div>
            </div>
          </main>
            <Chatbox userRole="recruteur" />
            {!isModal && <Footer />}
            <CustomAlert open={alertOpen} message={alertMessage} severity={alertSeverity} onClose={() => setAlertOpen(false)} />
            
            {/* Dialogue de confirmation moderne pour la suppression */}
            <Dialog
              open={confirmDialogOpen}
              onClose={handleCancelSave}
              aria-labelledby="confirm-dialog-title"
              aria-describedby="confirm-dialog-description"
            >
              <DialogTitle id="confirm-dialog-title">
                Confirmation de suppression
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="confirm-dialog-description">
                  {confirmMessage}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleCancelSave} color="secondary">
                  Annuler
                </Button>
                <Button onClick={handleConfirmSave} color="primary" variant="contained" autoFocus>
                  Confirmer
                </Button>
              </DialogActions>
            </Dialog>
      </div>
  );
};

export default DetailTalent;
